import React from "react"
import { browserHistory } from "react-router"
import { List, ListItem, Divider, Avatar, FontIcon } from "material-ui"
import HierarchyIcon from "material-ui/svg-icons/action/supervisor-account"
import RecordsIcon from "material-ui/svg-icons/av/library-books"
import EmployeesIcon from "material-ui/svg-icons/social/person"
import GearIcon from "material-ui/svg-icons/action/settings"
import HardwareComputer from "material-ui/svg-icons/hardware/computer"
import ImageTimer from "material-ui/svg-icons/image/timer"
import BuildIcon from "material-ui/svg-icons/action/build"
import SmartPhone from "material-ui/svg-icons/hardware/smartphone"
import AirPlane from "material-ui/svg-icons/device/airplanemode-active"
import ClientIcon from "material-ui/svg-icons/action/perm-contact-calendar"
import strings from "../../localization/strings"
import { IUserDocument, ELoggedInUserType } from "../../models"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
interface IProps {
	defaultHierarchySubItem: string
	cookieAccountId: string
	loggedInUser: IUserDocument
	active: any
	isAdmin: boolean
	loggedInUserType: ELoggedInUserType
	submenu: any
	showPayroll: boolean
	page: string
	showTimecards: boolean
	showLeaveTracking: boolean
	showEmployees: boolean
	showEquipment: boolean
	showRecords: boolean
	showTopLeveDevices: boolean
	showSchedule: boolean
	showClients: boolean
	showJobs: boolean
	showHierarchy: boolean
	showGigPool: boolean
	nestedUserMenuItems: object
}

const ExpandedLeftNav: React.SFC<IProps> = (props: IProps) => {
	const { loggedInUser, active, isAdmin, loggedInUserType } = props
	const menuTextStyle = { color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor, textDecoration: "none", padding: 0 }
	const selectedMenuTextStyle = { color: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor, textDecoration: "none", padding: 0 }
	const name = loggedInUser.FirstName + " " + loggedInUser.LastName
	const selectedListItemColor = AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor
	const unselectedListItemColor = AppStateStore.getFrontEndSettings().UISettings.MenuBackgroundColor
	const lockIcon = <img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/paywall-lock.png" style={{ width: 15, float: "right", marginTop: -3, marginRight: -5 }} />

	return (
        <div className="expanded-nav-container" style={{ zIndex: 1500 }}>
            <div className="side-nav-spacer" />
            <div className="ExpandedLeftNav side-nav" style={{ backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuBackgroundColor }}>
                <List >
                    <ListItem
                        primaryText={<span style={{ fontSize: 13, color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }}>{name}</span>}
                        leftAvatar={loggedInUser.ProfileImageS3Url ?
                                <Avatar src={loggedInUser.ProfileImageS3Url} /> :
                                <Avatar size={35}>{loggedInUser.FirstName[0].toUpperCase() + loggedInUser.LastName[0].toUpperCase()}</Avatar>
                                                    }
                        initiallyOpen={false}
                        primaryTogglesNestedList={true}
                        nestedItems={props.nestedUserMenuItems}
                    />
                </List>
                <Divider style={{ backgroundColor: unselectedListItemColor }} />
                {loggedInUserType !== ELoggedInUserType.Employee && (
                    <div>
                        <List style={{ backgroundColor: props.page === "/dashboard" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Dashboard}>
                            <ListItem
                                primaryText={strings.Dashboard}
                                onClick={() => browserHistory.push("/dashboard")}
                                style={props.page === "/dashboard" ? selectedMenuTextStyle : menuTextStyle}
                                leftIcon={<HardwareComputer style={{ fill: props.page === "/dashboard" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                            />
                        </List>
                        {active.dashboard && props.submenu}
                        {props.showPayroll && (
                            <List style={{ backgroundColor: props.page === "/payroll" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Payroll}>
                                <ListItem
                                    onClick={() => browserHistory.push("/payroll")}
                                    style={props.page === "/payroll" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<FontIcon className={"fa fa-money-bill"} color={props.page === "/payroll" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor} />}
                                >
                                    {strings.Payroll}
                                </ListItem>
                            </List>
                        )}
                        {props.showTimecards && (
                            <List style={{ backgroundColor: props.page === "/timecards" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Timecards}>
                                <ListItem
                                    onClick={() => browserHistory.push("/timecards")}
                                    style={props.page === "/timecards" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<ImageTimer style={{ fill: props.page === "/timecards" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                >
                                    {strings.Timecards}
                                </ListItem>
                            </List>
                        )}
                        {active.timecards && props.submenu}
                        {props.showLeaveTracking &&
                            <List style={{ backgroundColor: props.page === "/leave-tracking" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-Leave-Tracking"}>
                                <ListItem
                                    onClick={() => browserHistory.push("/leave-tracking")}
                                    style={props.page === "/leave-tracking" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<AirPlane style={{ fill: props.page === "/leave-tracking" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                >
                                    {strings.Leave_Tracking} {!AccountStore.getAccrualsTimeoffEnabled() && lockIcon}
                                </ListItem>
                            </List>
                        }
                        {props.showClients &&
                            <List style={{ backgroundColor: props.page.split("/")[1] === "clients" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Clients}>
                                <ListItem
                                    primaryText={strings.Clients}
                                    onClick={() => browserHistory.push("/clients")}
                                    style={props.page.split("/")[1] === "clients" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<ClientIcon style={{ fill: props.page.split("/")[1] === "clients" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                />
                            </List>
                        }
                        {props.showJobs &&
                            <List style={{ backgroundColor: props.page.split("/")[1] === "jobs" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Jobs}>
                                <ListItem
                                    primaryText={checkJobFieldAvailable("plural") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel : strings.Jobs}
                                    onClick={() => browserHistory.push("/jobs")}
                                    style={props.page.split("/")[1] === "jobs" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<FontIcon className="fa fa-shopping-bag" color={props.page.split("/")[1] === "jobs" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor} style={{ fontSize: 22 }} />}
                                />
                            </List>
                        }
                        {props.showSchedule &&
                            <List style={{ backgroundColor: unselectedListItemColor }} data-intercom-target={"menu-" + strings.Schedules}>
                                <ListItem
                                    onClick={() => browserHistory.push(`/schedule/${(!AccountStore.getScheduleEnabled() || (AccountStore.getScheduleEnabled() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule))) ? "posted_schedules" : "schedule_templates"}`)}
                                    style={menuTextStyle}
                                    leftIcon={<FontIcon className="fa fa-calendar" color={AppStateStore.getFrontEndSettings().UISettings.MenuIconColor} style={{ fontSize: 22 }} />}
                                >
                                    {strings.Schedules} {!AccountStore.getScheduleEnabled() && lockIcon}
                                </ListItem>
                            </List>
                        }
                        {active.schedule && AccountStore.getScheduleEnabled() && props.submenu}
                        {props.showEmployees &&
                            <List style={{ backgroundColor: props.page === "/employees" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Employees}>
                                <ListItem
                                    primaryText={strings.Employees}
                                    onClick={() => browserHistory.push("/employees")}
                                    style={props.page === "/employees" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<EmployeesIcon style={{ fill: props.page === "/employees" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                />
                            </List>
                        }

                        {props.showEquipment && (
                            <List style={props.page.split("/")[1] === "equipment" ? { backgroundColor: selectedListItemColor } : { backgroundColor: unselectedListItemColor }} data-intercom-target={"menu-" + strings.Equipment}>
                                <ListItem
                                    primaryText={strings.Equipment}
                                    onClick={() => browserHistory.push("/equipment")}
                                    style={props.page.split("/")[1] === "equipment" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<BuildIcon style={{ fill: props.page.split("/")[1] === "equipment" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                />
                            </List>
                        )}
                        {props.showRecords && (
                            <List style={{ backgroundColor: props.page === "/records" ? selectedListItemColor : unselectedListItemColor }} data-intercom-target={"menu-" + strings.Records}>
                                <ListItem
                                    primaryText={strings.Records}
                                    onClick={() => browserHistory.push("/records")}
                                    style={props.page === "/records" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<RecordsIcon style={{ fill: props.page === "/records" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                >
								</ListItem>
                            </List>
                        )}
                        {active.records && props.submenu}
                        {props.showTopLeveDevices && (
                            <List style={props.page === "/toplevel-devices" ? { backgroundColor: selectedListItemColor } : { backgroundColor: unselectedListItemColor }} data-intercom-target={"menu-" + strings.Devices}>
                                <ListItem
                                    primaryText={strings.Devices}
                                    onClick={() => browserHistory.push("/toplevel-devices")}
                                    style={props.page === "/toplevel-devices" ? selectedMenuTextStyle : menuTextStyle}
                                    leftIcon={<SmartPhone style={{ fill: props.page === "/toplevel-devices" ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                />
                            </List>
                        )}
                        {props.showHierarchy &&
                            <List style={{ backgroundColor: unselectedListItemColor }} data-intercom-target={"menu-" + strings.Hierarchy}>
                                <ListItem
                                    primaryText={strings.Hierarchy}
                                    onClick={() => browserHistory.push("/hierarchy/" + props.defaultHierarchySubItem)}
                                    style={menuTextStyle}
                                    leftIcon={<HierarchyIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuIconColor }} />}
                                />
                            </List>
                        }
                        {active.hierarchy && props.submenu}
                        {isAdmin &&
                            <div data-intercom-target={"menu-" + strings.Account}>
                                <List style={{ backgroundColor: unselectedListItemColor }}>
                                    <ListItem
                                        primaryText={strings.Account}
                                        onClick={() => browserHistory.push(`/account/${props.cookieAccountId}/Users`)}
                                        style={menuTextStyle}
                                        leftIcon={
                                            <GearIcon
                                                style={{
                                                    fill: AppStateStore.getFrontEndSettings().UISettings.MenuIconColor
                                                }}
                                            />
                                        }
                                    />
                                </List>
                                {active.account && props.submenu}
                            </div>
                        }
                    </div>
                )}
            </div>
        </div>
    )
}

export default ExpandedLeftNav
